import posthog from 'posthog-js';
import {
  getSchedulerRunId,
  SCHEDULER_RUN_HEADER,
} from '@/util/scheduling/schedulerRun';
import {
  ATTIK_REQUEST_ID_HEADER,
  createAttikRequestId,
} from '@/util/observability/requestId';
import { ATTIK_LOAD_ID_HEADER } from '@/util/observability/dashboardPerf/constants';

type TraceHeaders = {
  [ATTIK_REQUEST_ID_HEADER]: string;
  'x-posthog-distinct-id'?: string;
  'x-posthog-session-id'?: string;
  [ATTIK_LOAD_ID_HEADER]?: string;
  [SCHEDULER_RUN_HEADER]?: string;
};

/**
 * Adds PostHog identifiers so Express can link events back to the active session.
 * Also forwards `x-attik-scheduler-run-id` when the scheduler session has initialized storage.
 */
export function applyTraceHeaders<T extends Record<string, string | undefined>>(
  headers: T,
  requestId = createAttikRequestId()
): T & TraceHeaders {
  const runId = getSchedulerRunId();
  const distinctId = posthog.get_distinct_id();
  const sessionId = posthog.get_session_id();
  const outgoingRequestId = headers[ATTIK_REQUEST_ID_HEADER] || requestId;
  const loadId =
    headers[ATTIK_LOAD_ID_HEADER] ||
    (typeof window !== 'undefined'
      ? (window as unknown as { __attikDashboardLoadId?: string }).__attikDashboardLoadId
      : undefined);
  return {
    ...headers,
    [ATTIK_REQUEST_ID_HEADER]: outgoingRequestId,
    ...(distinctId ? { 'x-posthog-distinct-id': distinctId } : {}),
    ...(sessionId ? { 'x-posthog-session-id': sessionId } : {}),
    ...(loadId ? { [ATTIK_LOAD_ID_HEADER]: loadId } : {}),
    ...(runId ? { [SCHEDULER_RUN_HEADER]: runId } : {}),
  };
}
